/**
 * Swing/JSContext setFormError: null / empty / whitespace clears the form error panel.
 * Non-empty text is kept (newlines preserved; only ends trimmed).
 */
export function normalizeFormErrorMessage(message: unknown): string | null {
  if (message == null) return null
  if (typeof message === 'object' && !Array.isArray(message) && 'value' in message) {
    return normalizeFormErrorMessage((message as { value?: unknown }).value)
  }
  const text = String(message)
  if (!text.trim()) return null
  return text.replace(/^\s+/, '').replace(/\s+$/, '')
}
